import { apiSlice } from "../../app/api/apiSlice";

export const sqlApiSlice = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    getUserDetails: builder.query({
      query: () => ({
        url: "/users/Details",
        method: "GET",
      }),
    }),

    resetPassword: builder.mutation({
      query: (passwordData) => ({
        url: "/reset/reset-password",
        method: "POST",
        body: passwordData,
      }),
    }),
  }),
});

export const { useGetUserDetailsQuery, useResetPasswordMutation } = sqlApiSlice;
